import withRestrictedRoute from '@pcid/components/restricted-route';
import ForgotPassword from '../../containers/forgotPassword';

export default withRestrictedRoute(ForgotPassword);
